/**
 * Shared types / constants for sticky Talk To Expert banner configs.
 */

export const STICKY_BANNER_RULE_TYPES = {
  DEFAULT: "default",
  SCORE: "score",
  SUBJECT_MIN_MARK: "subjectMinMark",
  SCROLL_ELEMENT: "scrollElement",
  SCROLL_PERCENT: "scrollPercent"
};

/** How the banner picks its message */
export const BEHAVIOR_MODES = {
  /** Section / scroll-percent milestones (see scrollMilestones + scrollResolution) */
  SCROLL: "scroll",
  /** messageRules only (score / subject / default) — TODO: fill rules later */
  CONDITIONS: "conditions",
  /** Rotate carouselMessages when no scroll-driven copy applies */
  CAROUSEL: "carousel"
};

/** Page integration — drives resolver strategy */
export const STICKY_PAGE_TYPES = {
  /** Standard report route: score band × scroll milestone matrix */
  REPORT: "report",
  /** Olympiad / EMSAT style: priority scroll + messageId (no score matrix) */
  REPORT_EXTENSION: "reportExtension",
  /** Exam landing: static / carousel by messageId only (no score matrix) */
  EXAM: "exam"
};

/**
 * Report score-matrix copy variant (set on page sticky config).
 * Drives centralized `resolveStickyBannerMessage` / milestone matrix selection.
 */
export const STICKY_BANNER_EVENT_TYPES = {
  /** Default HOTS / multi-subject report matrix + subject resolver */
  GENERIC_REPORT: "genericReport",
  /** Maths Olympiad report — Maths-specific matrix */
  MATHS_OLYMPIAD: "mathsOlympiad"
};

/** Within SCROLL mode */
export const SCROLL_RESOLUTION = {
  /** Monotonic phases 1 → 2 → 3; only updates when phase changes (stable UX) */
  MILESTONE: "milestone",
  /** Legacy: highest-priority matching trigger (Olympiad / EMSAT) */
  PRIORITY: "priority"
};

export {};
